// Maximum canvas dimension. iOS Safari refuses to render canvases larger
// than ~4096px on a side, so cap height to avoid a blank background and
// memory pressure on long pages.
const MAX_CANVAS_DIMENSION = 4096;

const canvasDotsBg = function () {
  const canvas = document.querySelector('.canvas-2'),
    ctx = canvas.getContext('2d'),
    colorDot = [
      'rgb(92, 95, 124)',
      'rgb(92, 95, 124)',
      'rgb(92, 95, 124)',
      'rgb(178, 151, 88)',
    ], // 75% of dots are primary blue-gray. 25% golden
    color = 'rgb(92, 95, 124)';

  const windowSize = window.innerWidth;

  // On phones the canvas is fully transparent (alpha 0), so skip every
  // expensive operation: large allocations, animation frames, observers.
  // The fixed div behind already paints the solid background color.
  if (windowSize <= 800) {
    canvas.style.display = 'none';
    return;
  }

  function getCanvasHeight() {
    const fullHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight,
      window.innerHeight
    );
    return Math.min(fullHeight, MAX_CANVAS_DIMENSION);
  }

  let canvasHeight = getCanvasHeight();

  const mainBg = document.querySelector('.main-bg');
  if (mainBg) {
    mainBg.style.height = canvasHeight + 'px';
  }

  canvas.width = Math.min(document.body.scrollWidth, MAX_CANVAS_DIMENSION);
  canvas.height = canvasHeight;
  canvas.style.display = 'block';
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  ctx.lineWidth = 0.3;
  ctx.strokeStyle = color;

  let mousePosition = {
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
  };

  let dots;

  if (windowSize > 1600) {
    dots = {
      nb: 150, // capped — 1500 dots animating continuously was pure CPU burn
      distance: 50,
      d_radius: 100, // enable mouse follower in about section
      array: [],
    };
  } else if (windowSize > 1300) {
    dots = {
      nb: 120,
      distance: 45,
      d_radius: 90,
      array: [],
    };
  } else if (windowSize > 1100) {
    dots = {
      nb: 80,
      distance: 40,
      d_radius: 80,
      array: [],
    };
  } else {
    // 800 < windowSize <= 1100: keep canvas active but invisible
    dots = {
      nb: 1,
      distance: 0,
      d_radius: 0,
      array: [],
    };
    ctx.globalAlpha = 0;
  }

  function Dot() {
    this.x = Math.random() * canvas.width;
    this.y = Math.random() * canvas.height;

    this.vx = (-0.5 + Math.random()) * 0.5;
    this.vy = (-0.5 + Math.random()) * 0.5;

    this.radius = Math.random() * 1.5 + 0.3;

    this.colour = colorDot[Math.floor(Math.random() * colorDot.length)];
  }

  Dot.prototype = {
    create: function () {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);

      // Account for scroll position since the bg is fixed and uses mouse position
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      // Calculate mouse position relative to canvas (accounting for scroll)
      const mouseX = mousePosition.x;
      const mouseY = mousePosition.y - scrollTop;

      // make the dot colour fade out the further they are from the mouse
      const dotDistance =
        ((this.x - mouseX) ** 2 + (this.y - mouseY) ** 2) ** 0.5;
      const distanceRatio = dotDistance / (windowSize / 2);

      // Ensure minimum opacity so dots are always visible (at least 0.5 opacity)
      const opacity = Math.max(0.5, 1 - distanceRatio * 0.5);

      ctx.fillStyle = this.colour.slice(0, -1) + `,${opacity})`;

      ctx.fill();
    },


    line: function () {
      for (let i = 0; i < dots.nb; i++) {
        for (let j = 0; j < dots.nb; j++) {
          const i_dot = dots.array[i];
          const j_dot = dots.array[j];

          if (
            i_dot.x - j_dot.x < dots.distance &&
            i_dot.y - j_dot.y < dots.distance &&
            i_dot.x - j_dot.x > -dots.distance &&
            i_dot.y - j_dot.y > -dots.distance
          ) {
            if (
              i_dot.x - mousePosition.x < dots.d_radius &&
              i_dot.y - mousePosition.y < dots.d_radius &&
              i_dot.x - mousePosition.x > -dots.d_radius &&
              i_dot.y - mousePosition.y > -dots.d_radius
            ) {
              ctx.beginPath();
              ctx.moveTo(i_dot.x, i_dot.y);
              ctx.lineTo(j_dot.x, j_dot.y);

              const dotDistance =
                ((i_dot.x - mousePosition.x) ** 2 +
                  (i_dot.y - mousePosition.y) ** 2) **
                0.5;
              let distanceRatio = dotDistance / dots.d_radius;

              distanceRatio -= 0.3;
              if (distanceRatio < 0) {
                distanceRatio = 0;
              }

              ctx.strokeStyle = `rgb(81, 162, 233, ${1 - distanceRatio})`;

              ctx.stroke();
              ctx.closePath();
            }
          }
        }
      }
    },
  };

  function initializeDots() {
    dots.array = [];
    for (let i = 0; i < dots.nb; i++) {
      dots.array.push(new Dot());
    }

    dots.array[0].radius = 1.5;
    dots.array[0].colour = '#51a2e9';
  }

  function render() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (let i = 0; i < dots.array.length; i++) {
      dots.array[i].create();
    }
  }

  function animate() {
    for (let i = 1; i < dots.nb; i++) {
      const dot = dots.array[i];

      if (dot.y < 0 || dot.y > canvas.height) {
        dot.vx = dot.vx;
        dot.vy = -dot.vy;
      } else if (dot.x < 0 || dot.x > canvas.width) {
        dot.vx = -dot.vx;
        dot.vy = dot.vy;
      }
      dot.x += dot.vx;
      dot.y += dot.vy;
    }
  }

  window.onmousemove = function (parameter) {
    mousePosition.x = parameter.pageX;
    mousePosition.y = parameter.pageY;

    try {
      if (dots.array && dots.array.length > 0) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        dots.array[0].x = parameter.pageX;
        dots.array[0].y = parameter.pageY - scrollTop;
      }
    } catch {
      //
    }
  };

  window.onscroll = function () {
    mousePosition.x = window.innerWidth / 2;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    mousePosition.y = window.innerHeight / 2 + scrollTop;
  };

  mousePosition.x = window.innerWidth / 2;
  mousePosition.y = window.innerHeight / 2;

  initializeDots();

  let animationFrameId;

  function animationLoop() {
    animate();
    render();
    animationFrameId = requestAnimationFrame(animationLoop);
  }

  // Reduced motion: draw the starfield once and leave it static.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    render();
  } else {
    animationFrameId = requestAnimationFrame(animationLoop);
  }

  let resizeTimer;
  window.onresize = function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      canvasDotsBg();
    }, 200);
  };

  // Cheap, throttled height sync. The previous MutationObserver fired on
  // every reveal-class toggle while scrolling, which caused jank on iPhone.
  let heightSyncTimer;
  function scheduleHeightSync() {
    if (heightSyncTimer) return;
    heightSyncTimer = setTimeout(() => {
      heightSyncTimer = null;
      const newHeight = getCanvasHeight();
      if (canvas.height !== newHeight) {
        canvas.height = newHeight;
        if (mainBg) mainBg.style.height = newHeight + 'px';
      }
    }, 500);
  }

  window.addEventListener('load', scheduleHeightSync);
  window.addEventListener('resize', scheduleHeightSync);
};

export default canvasDotsBg;
